import { Avatar } from "../../../Component/MiscComponent/PrimitiveComponent";

export const ProfileContent = ({ data }) => {
  const cp = data.currentPeriod;
  const psb = data.psb?.[0];
  const isPsb = cp.type==="psb";
  const packageStats = [
      [
        "PPPoE Username",
        isPsb ? cp.pppoe_username: psb?.pppoe_username,
        true
      ],
      [
        "ODP",
        isPsb? cp.nearest_odp_id: psb?.nearest_odp_id,
        false
      ],
      [
        "Paket",
        cp.itemName || psb?.itemName,
        false
      ],
      [
        "Kategori",
        cp.category,
        false
      ]
    ]

  const userProfileStats = [
    [
      "ID Pelanggan",
      cp.customerId || cp.customer_id],
    [
      "Email",
      cp.email
    ],
    // [
    //   "No. HP",
    //   cp.mobile_no
    // ],
    // [
    //   "No. KTP",
    //   cp.ktp
    // ],
    [
      "Grup",
      cp.customergroup
    ],
    [
      "Wilayah",
      cp.teritory
    ]
  ]

  const addressStats = [
    [
      "Nama Alamat",
      cp.address_title
    ],
    [
      "Tipe",
      cp.address_type
    ],
    [
      "Kelurahan",
      cp.urban
    ],
    [
      "Kecamatan",
      cp.sub_district
    ],
    [
      "Kota",
      cp.city
    ],
    [
      "Provinsi",
      cp.province_name
    ]
  ]

  return (
    <div style={{ display:"flex", flexDirection:"column", gap:20 }}>
      <div>
        <div style={{ fontSize:20, fontWeight:800, marginBottom:4 }}>Profile
        </div>
        <div className="txt-muted">Informasi akun dan koneksi Anda
        </div>

      </div>
      <div className="grid-7-5">
        <div className="card">
          <div className="card-body">
            <div className="flex items-center gap-3" style={{ marginBottom:20 }}>
              <Avatar name={`${cp.firstname} ${cp.lastname}`} large />
              <div><div style={{ fontSize:18, fontWeight:800, marginBottom:6 }}>{cp.firstname} {cp.lastname}

              </div>
              <span className="badge badge-success">Aktif</span>
              </div>
            </div>
            {userProfileStats.map(([l,v])=>(
              <div className="rounded-row" key={l}>
                <span className="txt-muted">{l}</span>
              <span className="txt-val">{v}</span>
              </div>
            ))}
          </div>
        </div>
        <div style={{ display:"flex", flexDirection:"column", gap:16 }}>
          <div className="card">
            <div className="card-body">
              <div className="section-title">Alamat Pemasangan

              </div>
              {addressStats.map(([l,v])=>(
                <div className="rounded-row" key={l}>
                  <span className="txt-muted">{l}</span>
                <span className="txt-val">{v||"-"}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="card">
            <div className="card-body">
              <div className="section-title">Informasi Jaringan

              </div>
              {
              packageStats.map(([l,v,m])=>(
                <div className="rounded-row" key={l}>
                  <span className="txt-muted">{l}</span>
                <span className={`txt-val ${m?"mono":""}`} style={{ fontSize:m?12:14 }}>{v||"-"}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};